import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectContracts, selectIsLoading } from '../DashboardV2Selectors'
import { Contract } from '../types'

interface SortState {
  key: string
  direction: 'ASC' | 'DESC' | null
}

const useContractsTable = (businessType: string) => {
  const contracts = useSelector(selectContracts)
  const isLoading = useSelector(selectIsLoading)
  const [sort, setSort] = useState<SortState>({ key: '', direction: null })

  // Keep businessType for future use
  void businessType

  const handleSort = (columnKey: string) => {
    setSort(prev => {
      if (prev.key !== columnKey) return { key: columnKey, direction: 'ASC' }
      if (prev.direction === 'ASC') return { key: columnKey, direction: 'DESC' }
      return { key: '', direction: null }
    })
  }

  const sortedContracts = useMemo(() => {
    if (!sort.key || !sort.direction) return contracts

    return [...contracts].sort((a: Contract, b: Contract) => {
      const aVal = String(a[sort.key] ?? '')
      const bVal = String(b[sort.key] ?? '')
      const comparison = aVal.localeCompare(bVal)
      return sort.direction === 'ASC' ? comparison : -comparison
    })
  }, [contracts, sort])

  return {
    sortedContracts,
    isLoading,
    sort,
    handleSort,
  }
}

export default useContractsTable
